const CanvaIcon = (props) => {
  const { color = "currentColor" } = props;
  return (
    <svg width="9" height="12" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.73823 5.13246C5.68872 5.13246 5.64515 5.17428 5.5998 5.2656C5.08772 6.30397 4.20326 7.03869 3.17975 7.03869C1.99629 7.03869 1.26342 5.97037 1.26342 4.49451C1.26342 1.99451 2.65635 0.549045 3.87981 0.549045C4.45152 0.549045 4.80066 0.908325 4.80066 1.48006C4.80066 2.15862 4.41515 2.5179 4.41515 2.75721C4.41515 2.86464 4.48197 2.92968 4.61446 2.92968C5.14683 2.92968 5.77166 2.31796 5.77166 1.4538C5.77166 0.615885 5.04237 0 3.81894 0C1.79697 0 0 1.87455 0 4.46823C0 6.47589 1.14645 7.80259 2.91537 7.80259C4.79289 7.80259 5.87852 5.93457 5.87852 5.32825C5.87852 5.19397 5.80986 5.13246 5.73823 5.13246Z"
        fill={color}
      />
    </svg>
  );
};

export default CanvaIcon;
